module.exports = __webpack_public_path__ + "img/web_success.e5fee0de.jpg";